import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import DetailsButtonPicker
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/ScenarioMessageContent/DetailsButtonPicker';
import { FDStack, FDBodyText } from '@facet-wealth/design';


const ScenarioMessageContent = ({
  messageResource,
  onLoadComplete,
}) => {
  useComponentDidMount(() => {
    onLoadComplete();
  });

  return (
    <FDStack alignItems={'center'} direction={'column'} padding={2} spacing={2}>
      <FDBodyText value={'Scenario'} size={'lg'} color={'textSecondary'} />
      <DetailsButtonPicker messageResource={messageResource} />
    </FDStack>
  );
};

ScenarioMessageContent.defaultProps = {
  onLoadComplete: noop,
};

ScenarioMessageContent.propTypes = {
  messageResource: PropTypes.object.isRequired,
  onLoadComplete: PropTypes.func,
};


export default ScenarioMessageContent;
